const BOOKING_DRAFT_KEY = "telefonka-booking-draft-v5";
const GUARD_FLAG = Symbol.for("telefonka.bookingDraftPrivacyGuard");

/**
 * Telefonka booking choices live only in React state for the current page session.
 * Nothing from the booking flow is allowed to persist in localStorage across reloads.
 */
export const installBookingDraftPrivacyGuard = () => {
  if (typeof window === "undefined") return;

  try {
    const storage = window.localStorage;
    if (!storage) return;

    const storagePrototype = Object.getPrototypeOf(storage);
    if (!storagePrototype || storagePrototype[GUARD_FLAG]) return;

    const originalGetItem = storagePrototype.getItem;
    const originalSetItem = storagePrototype.setItem;
    const originalRemoveItem = storagePrototype.removeItem;

    // Remove any draft left behind by previous versions immediately on startup.
    originalRemoveItem.call(storage, BOOKING_DRAFT_KEY);

    Object.defineProperty(storagePrototype, "getItem", {
      configurable: true,
      writable: true,
      value(key) {
        if (this === storage && key === BOOKING_DRAFT_KEY) {
          return null;
        }
        return originalGetItem.call(this, key);
      },
    });

    Object.defineProperty(storagePrototype, "setItem", {
      configurable: true,
      writable: true,
      value(key, value) {
        if (this === storage && key === BOOKING_DRAFT_KEY) {
          originalRemoveItem.call(this, key);
          return undefined;
        }
        return originalSetItem.call(this, key, value);
      },
    });

    Object.defineProperty(storagePrototype, GUARD_FLAG, {
      configurable: false,
      enumerable: false,
      writable: false,
      value: true,
    });
  } catch (_) {
    // Booking remains functional in strict/private browser modes where storage
    // access or prototype changes are blocked. No payment validity relies on it.
  }
};

installBookingDraftPrivacyGuard();

export { BOOKING_DRAFT_KEY };
